'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _templateData = require('redux/modules/templateData');

var templateActions = _interopRequireWildcard(_templateData);

var _reactColor = require('react-color');

var _semanticUiReact = require('semantic-ui-react');

var _components = require('components');

var _recharts = require('recharts');

require('./Chart.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./Chart.scss');

var getPath = function getPath(x, y, width, height) {
  return 'M' + x + ',' + (y + height) + '\n          C' + (x + width / 3) + ',' + (y + height) + ' ' + (x + width / 2) + ',' + (y + height / 3) + ' ' + (x + width / 2) + ', ' + y + '\n          C' + (x + width / 2) + ',' + (y + height / 3) + ' ' + (x + 2 * width / 3) + ',' + (y + height) + ' ' + (x + width) + ', ' + (y + height) + '\n          Z';
};

var TriangleBar = function TriangleBar(props) {
  var fill = props.fill,
      x = props.x,
      y = props.y,
      width = props.width,
      height = props.height;


  return _react2.default.createElement('path', { d: getPath(x, y, width, height), stroke: 'none', fill: fill });
};

var Chart = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    primary_color: state.templateData.primary_color,
    secondary_color: state.templateData.secondary_color,
    info_block: state.templateData.info_block
  };
}, {
  updateChartData: templateActions.updateField
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Chart, _Component);

  function Chart(props) {
    (0, _classCallCheck3.default)(this, Chart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Chart.__proto__ || (0, _getPrototypeOf2.default)(Chart)).call(this, props));

    _this.handleClick = function () {
      _this.setState({ chartEditorVisible: _this.state.chartEditorVisible ? false : true });
    };

    _this.handleChartVisibility = function () {
      _this.setState({ chartEditorVisible: false });
    };

    _this.changeChart = function (e, chart_type, elementParent, elementID) {
      _this.props.updateChartData(chart_type, elementID, 'chart_type', elementParent);
      _this.setState({ chart_type: chart_type });
    };

    _this.renderChart = function (chart_type, data, primary_color, secondary_color) {
      switch (chart_type) {
        case 'pie':
          return _react2.default.createElement(
            _recharts.PieChart,
            null,
            _react2.default.createElement(
              _recharts.Pie,
              { isAnimationActive: false, data: data, paddingAngle: 2, dataKey: 'x', nameKey: 'skill', cx: '50%', cy: '50%', innerRadius: 40, outerRadius: 50, fill: primary_color },
              _react2.default.createElement(_recharts.LabelList, { dataKey: 'skill', fontSize: 10, strokeWidth: 0.5, stroke: primary_color, fill: primary_color, position: 'outside' })
            )
          );
          break;
        case 'bar':
          return _react2.default.createElement(
            _recharts.BarChart,
            { layout: 'vertical', data: data },
            _react2.default.createElement(_recharts.YAxis, { width: 5, tick: false, fill: primary_color, type: 'category', dataKey: 'skill' }),
            _react2.default.createElement(_recharts.XAxis, { type: 'number', hide: true }),
            _react2.default.createElement(
              _recharts.Bar,
              { barSize: 20, dataKey: 'x', fill: primary_color },
              _react2.default.createElement(_recharts.LabelList, { dataKey: 'skill', fontSize: 10, stroke: secondary_color, strokeWidth: 0.5, fill: secondary_color, position: 'insideLeft' })
            )
          );
          break;
        case 'col':
          return _react2.default.createElement(
            _recharts.BarChart,
            { layout: 'horizontal', data: data, margin: { top: 40 } },
            _react2.default.createElement(_recharts.YAxis, { type: 'number', hide: true }),
            _react2.default.createElement(_recharts.XAxis, { width: 5, tick: false, fill: primary_color, type: 'category', dataKey: 'skill' }),
            _react2.default.createElement(
              _recharts.Bar,
              { barSize: 20, dataKey: 'x', fill: primary_color },
              _react2.default.createElement(_recharts.LabelList, { dataKey: 'skill', fontSize: 10, stroke: primary_color, strokeWidth: 0.5, fill: primary_color, position: 'top' })
            )
          );
          break;
        case 'tri':
          return _react2.default.createElement(
            _recharts.BarChart,
            { layout: 'horizontal', data: data, margin: { top: 40 } },
            _react2.default.createElement(_recharts.YAxis, { type: 'number', hide: true }),
            _react2.default.createElement(_recharts.XAxis, { width: 5, tick: false, fill: primary_color, type: 'category', dataKey: 'skill' }),
            _react2.default.createElement(
              _recharts.Bar,
              { dataKey: 'x', fill: primary_color, shape: _react2.default.createElement(TriangleBar, null) },
              _react2.default.createElement(_recharts.LabelList, { dataKey: 'skill', fontSize: 10, stroke: primary_color, strokeWidth: 0.5, fill: primary_color, position: 'top' })
            )
          );
          break;
        default:
          return null;
      }
    };

    _this.state = {
      chartX: 0,
      chartY: 0,
      chartEditorVisible: false,
      chart_type: ''
      // chartDataArray: []
    };
    return _this;
  }

  (0, _createClass3.default)(Chart, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var chart_type;
      var info_block = this.props.info_block[this.props.data_parent];
      chart_type = info_block[this.props.data_id]['chart_type'];
      this.setState({ chart_type: chart_type });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          chartX = _state.chartX,
          chartY = _state.chartY,
          chartEditorVisible = _state.chartEditorVisible,
          chart_type = _state.chart_type;
      var _props = this.props,
          info_block = _props.info_block,
          data_parent = _props.data_parent,
          data_id = _props.data_id,
          data_type = _props.data_type,
          primary_color = _props.primary_color,
          secondary_color = _props.secondary_color;


      var data = info_block[data_parent][data_id][data_type] === '' ? false : JSON.parse(info_block[data_parent][data_id][data_type]);

      var aspectRatio = this.props.dataAspectRatio === '' ? 1 : !isNaN(this.props.dataAspectRatio) ? parseFloat(this.props.dataAspectRatio) : 1;

      return _react2.default.createElement(
        'div',
        { className: 'chartWrapper ' + chart_type + '-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'hideChartIcon' },
          _react2.default.createElement(
            'div',
            { className: 'singleIcon' },
            _react2.default.createElement(_semanticUiReact.Icon, { onClick: this.handleClick, name: 'edit' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'singleIcon ' + (chart_type === 'bar' ? 'activeChart' : 'inactiveChart') },
            _react2.default.createElement(_semanticUiReact.Icon, { onClick: function onClick(e) {
                return _this2.changeChart(e, 'bar', data_parent, data_id);
              }, name: 'bars' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'singleIcon ' + (chart_type === 'col' ? 'activeChart' : 'inactiveChart') },
            _react2.default.createElement(_semanticUiReact.Icon, { onClick: function onClick(e) {
                return _this2.changeChart(e, 'col', data_parent, data_id);
              }, name: 'bar chart' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'singleIcon ' + (chart_type === 'pie' ? 'activeChart' : 'inactiveChart') },
            _react2.default.createElement(_semanticUiReact.Icon, { onClick: function onClick(e) {
                return _this2.changeChart(e, 'pie', data_parent, data_id);
              }, name: 'pie chart' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'singleIcon ' + (chart_type === 'tri' ? 'activeChart' : 'inactiveChart') },
            _react2.default.createElement(_semanticUiReact.Icon, { onClick: function onClick(e) {
                return _this2.changeChart(e, 'tri', data_parent, data_id);
              }, name: 'area chart' })
          )
        ),
        _react2.default.createElement(
          _recharts.ResponsiveContainer,
          { aspect: aspectRatio },
          this.renderChart(chart_type, data, primary_color, secondary_color)
        ),
        chartEditorVisible && _react2.default.createElement(_components.ChartEditor, {
          data_parent: this.props.data_parent,
          data_id: this.props.data_id,
          data_type: this.props.data_type,
          chartX: chartX,
          chartY: chartY,
          handleChartVisibility: this.handleChartVisibility
        })
      );
    }
  }]);
  return Chart;
}(_react.Component)) || _class);
exports.default = Chart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chart/Chart.js
// module id = 1731
// module chunks = 0